import { ListProps } from '@mui/material';
import { ListContainer, ListHeader } from 'components/CompleteFooter/CompleteFooter.styles';
import React from 'react';
import RenderItem from '../RenderItem';

const RenderList = ({
  itemList,
}: {
  itemList: ListProps & { beneathItems: any[]; TEXT: string };
}): React.ReactElement<any> => (
  <ListContainer>
    <ListHeader role='heading' aria-level='3'>
      {itemList.TEXT}
    </ListHeader>
    {itemList.beneathItems.map((beneathItem) => (
      <RenderItem item={beneathItem} />
    ))}
  </ListContainer>
);

export default RenderList;
